import { Button, Modal } from '@basqet-dashboard/common/components';
import { useNavigateTo } from '@basqet-dashboard/common/utils';
import PropTypes from 'prop-types';
import React from 'react';

const SelectPayoutTransferTypeModal = ({ onModalClose }) => {
  const { navigateTo } = useNavigateTo();

  return (
    <Modal onModalClose={onModalClose} header={{ name: 'Select Transaction Type' }}>
      <div className="payout__form">
        <div className="payout__form__group">
          <Button isFull onClick={() => navigateTo('/payouts/single-transfer')}>
            Single Transfer
          </Button>
          <Button isFull onClick={() => navigateTo('/payouts/bulk-transfer')}>
            Bulk Transfer
          </Button>
        </div>
      </div>
    </Modal>
  );
};

SelectPayoutTransferTypeModal.propTypes = {
  onModalClose: PropTypes.func
};

export { SelectPayoutTransferTypeModal };
